import React, { createContext, useContext, useMemo } from 'react';
import { ThemeProvider as MuiThemeProvider, CssBaseline } from '@mui/material';
import { useAppSelector } from '@/store';
import { lightTheme, darkTheme } from '@/themes/theme';

interface ThemeContextValue {
  isDarkMode: boolean;
}

const ThemeContext = createContext<ThemeContextValue>({
  isDarkMode: false,
});

export const useTheme = () => useContext(ThemeContext);

interface AppThemeProviderProps {
  children: React.ReactNode;
}

export const AppThemeProvider: React.FC<AppThemeProviderProps> = ({ children }) => {
  const themeMode = useAppSelector((state) => state.ui.theme);
  const isDarkMode = themeMode === 'dark';

  const theme = useMemo(() => {
    return isDarkMode ? darkTheme : lightTheme;
  }, [isDarkMode]);

  const contextValue = useMemo(
    () => ({
      isDarkMode,
    }),
    [isDarkMode]
  );

  return (
    <ThemeContext.Provider value={contextValue}>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MuiThemeProvider>
    </ThemeContext.Provider>
  );
};